import { createContext, ReactNode, useContext, useState } from "react";

interface BreadcrumbContextType {
  title: string | null;
  setTitle: (title: string | null) => void;
  query: string | null;
  setQuery: (query: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<string | null>(null);
  const [query, setQuery] = useState<string | null>(null);

  return <BreadcrumbContext.Provider value={{ title, setTitle, query, setQuery }}>{children}</BreadcrumbContext.Provider>;
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (context === undefined) {
    throw new Error("useBreadcrumb must be used within a BreadcrumbProvider");
  }
  return context;
};
